export default {
  namespaced: true,

  state: {
    show: false,
    items: []
  },

  mutations: {
    toggle(state) {
      state.show = !state.show;
    },

    set(state, notifications) {
      state.items = notifications;
    }
  },

  getters: {
    all(state) {
      return state.items;
    },

    count(state) {
      return state.items.length;
    }
  }
};
